module.exports = __webpack_public_path__ + "media/images/ac_templates/201/grpht-5401524ab46fce6aef39b8a2e0b03f86.jpg";